import Action from "./comps/Action";
import Header from "./comps/Header";
import Price from "./comps/Price";
import Details from "./comps/Details";
import Text from "components/Table2/CellComps/Text";
import PriceComp from "components/Table2/CellComps/Price";
import {useDispatch, useSelector} from "react-redux";
import Box from "./comps/Box";
import Info from "./comps/Info";
import {SetStateAction, useEffect, useState} from "react";
import {apiDeleteAccountings, apiGetAccounting} from "api/accountingApi";
import {useNavigate} from "react-router-dom";
import {addOpenDrawer, setConfirm} from "store/actions/appAction";
import EditImg from "assets/images/Edit.svg";
import DeleteImg from "assets/images/Delete.svg";
import {
  apiCreateNotifications,
  apiDeleteNotifications,
  apiEditNotifications,
  apiGetItemNotifications,
} from "api/notificationApi";
import {apiGetHistory, apiGetItemNote} from "api/noteApi";
import {Tab, Tabs} from "@mui/material";
import {TabPanel} from "./FactorDrawer";
import DrawerHistory from "./comps/DrawerHistory";
import Table from "components/Table2";

const initialTable: TableProps = {
    headers: [
        {label: "حساب"},
        {label: "تفصیل"},
        {label: "بدهکار"},
        {label: "بستانکار"},
        {label: "مبلغ"},
    ],
    cols: [
        {Comp: Text, key: "account"},
        {Comp: Text, key: "detail"},
        {Comp: PriceComp, key: "debt"},
        {Comp: PriceComp, key: "credit"},
        {Comp: PriceComp, key: "price"},
    ],
    headerColor: "#fff",
    rows: [],
    withoutMenu: true,
};

export default function AccountingDrawer() {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const {drawerProps, anchor} = useSelector((state: any) => state).appReducer;

    const token = useSelector((state: any) => state).businessReducer.business?.token;

    const [accounting, setAccounting] = useState(drawerProps?.accounting);
    const [table, setTable] = useState(initialTable);

    useEffect(() => {
        if (accounting) {
            dispatch(
                // @ts-ignore
                apiGetAccounting(
                    accounting.AccountingId ?? accounting.id,
                    accounting.AccountingType ?? accounting.type,
                    token,
                    (accountingObject: any) => {
                        const newAccounting = {...accounting, ...accountingObject};
                        renderTable(newAccounting);
                        setAccounting(newAccounting);
                    }
                )
            );
            initialNote();
        }
    }, []);

    // modal state
    const [openModal, setOpenModal] = useState(false);
    const handleOpenModal = () => setOpenModal(true);
    const handleCloseModal = () => setOpenModal(false);
    const [notificationsList, setNotificationList] = useState([]);
    const [noteList, setNoteList] = useState([]);
    // ===modal state

    // notification functions
    const handleDeleteNotification = (id: any) => {
        dispatch(
            // @ts-ignore
            apiDeleteNotifications(token, id, () => {
                dispatch(
                    // @ts-ignore
                    apiGetItemNotifications(
                        token,
                        accounting.AccountingId ?? accounting.id,
                        "Accounting",
                        (value: SetStateAction<never[]>) => {
                            setNotificationList(value);
                        }
                    )
                );
            })
        );
    };
    const handelChangeActive = (value: any) => {
        dispatch(
            // @ts-ignore
            apiEditNotifications(token, value?.id, value.active, () => {
                dispatch(
                    // @ts-ignore
                    apiGetItemNotifications(
                        token,
                        accounting.AccountingId ?? accounting.id,
                        "Accounting",
                        (value: SetStateAction<never[]>) => {
                            setNotificationList(value);
                        }
                    )
                );
            })
        );
    };

    const submitNotification = (value: any) => {
        dispatch(
            // @ts-ignore
            apiCreateNotifications(
                token,
                accounting.AccountingId ?? accounting.id,
                "Accounting",
                value?.title,
                value?.description,
                value.fireDate,
                () => {
                    dispatch(
                        // @ts-ignore
                        apiGetItemNotifications(
                            token,
                            accounting.AccountingId ?? accounting.id,
                            "Accounting",
                            (value: SetStateAction<never[]>) => {
                                setNotificationList(value);
                            }
                        )
                    );
                    handleCloseModal();
                }
            )
        );
    };
    //=== notification functions

    // tabs state
    const [value, setValue] = useState(0);
    // ===state
    // tab function
    const handleChange = (event: React.SyntheticEvent, newValue: number) => {
        setValue(newValue);
    };

    function a11yProps(index: number) {
        return {
            id: `simple-tab-${index}`,
            "aria-controls": `simple-tabpanel-${index}`,
        };
    }

    //===========

    // ===transaction
    const [History, setHistory] = useState([]);

    // ===

    const initialNote = () => {
        dispatch(
            // @ts-ignore
            apiGetItemNote(
                token,
                accounting.AccountingId ?? accounting.id,
                "Accounting",
                (value: SetStateAction<never[]>) => {
                    setNoteList(value);
                }
            )
        );
        dispatch(
            // @ts-ignore
            apiGetHistory(
                token,
                accounting.AccountingId ?? accounting.id,
                "Accounting",
                (value: SetStateAction<never[]>) => {
                    setHistory(value);
                }
            )
        );
    };

    if (!accounting) return <></>;

    const closeDrawer = () => dispatch(addOpenDrawer(false, undefined, anchor));
    const editAccounting = () => {
        closeDrawer();
        navigate(`/accounting/${accounting.AccountingId ?? accounting.id}`);
    };

    const deleteAccounting = () => {
        closeDrawer();
        dispatch(
            // @ts-ignore
            setConfirm("حذف سند", () =>
                // @ts-ignore
                dispatch(
                    // @ts-ignore
                    apiDeleteAccountings(
                        [accounting.AccountingId ?? accounting.id],
                        token,
                        // @ts-ignore
                        {key: accounting.type}
                    )
                )
            )
        );
    };

    const actions = {
        menu: [
            {
                label: "ویرایش",
                icon: <img src={EditImg} alt=""/>,
                onClick: editAccounting,
                show: true,
            },
            {
                Label: <span style={{color: "#F42222", fontSize: "12px", fontWeight: 700}}>حذف</span>,
                icon: <img src={DeleteImg} alt=""/>,
                onClick: deleteAccounting,
                show: true,
            },
        ],
    };

    const details = [];
    accounting.date && details.push(`تاریخ ثبت: ${accounting.date}`);

    const renderTable = (accounting: any) => {
        const rows: any = [];

        accounting.Accounting_Items.map((item: any) => {
            rows.push({
                account: item.Account_Type?.title,
                detail: item.detail,
                debt: item.isCreditor ? 0 : item.amount,
                credit: item.isCreditor ? item.amount : 0,
                price: item.amount,
            });
        });

        setTable({
            ...initialTable,
            rows,
        });
    };

    return (
        <div style={{backgroundColor: "#FCFEFF", height: "100vh"}}>
            <Header heading={"سند حسابداری"} id={`${accounting.accountingCode}`}/>
            <Action
                actions={actions}
                side={
                    <div>
                        <Price price={accounting.amount} currency={accounting.Currency}/>
                    </div>
                }
                withReminder
                fireDate={undefined}
                submitNotification={(value) => {
                    submitNotification(value);
                }}
                openModal={openModal}
                handleCloseModal={handleCloseModal}
                handleOpenModal={handleOpenModal}
                deleteItem={(id) => handleDeleteNotification(id)}
                updateNotification={(val) => handelChangeActive(val)}
                reminderData={notificationsList}
            />
            <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
                <Tab label="خلاصه" {...a11yProps(0)} />
                <Tab label="تاریخچه" {...a11yProps(1)} />
            </Tabs>
            <TabPanel value={value} index={0}>
                <div style={{padding: "0px 32px"}}>
                    <Details details={details}/>
                    <Box>
                        <div style={{display: "flex", justifyContent: "space-between"}}>
                            <div style={{display: "flex", flexDirection: "column", gap: 24}}>
                                <div style={{display: "flex", gap: 20}}>
                                    <Info title="#" info={accounting.accountingCode}/>
                                    <Info title="شرح سند" info={accounting.description}/>
                                </div>
                                <div style={{display: "flex", gap: 20}}>
                                    {accounting?.Project && <Info title="پروژه" info={accounting.Project.title}/>}
                                    {accounting?.Branch && <Info title="شعبه" info={accounting.Branch.title}/>}
                                </div>
                            </div>
                        </div>
                    </Box>
                </div>

                <div style={{padding: "16px 32px"}}>
                    <Box>
                        <div
                            style={{
                                whiteSpace: "nowrap",
                                overflow: "auto",
                                position: "relative",
                            }}
                        >
                            <Table {...table} />
                        </div>
                    </Box>
                </div>
            </TabPanel>
            <TabPanel value={value} index={1}>
                <DrawerHistory
                    title={"سند حسابداری"}
                    history={History}
                    noteList={noteList}
                    token={token}
                    detail_type="Accounting"
                    id={accounting.AccountingId ?? accounting.id}
                    refresh={() => {
                        initialNote();
                    }}
                />
            </TabPanel>
        </div>
    );
}
